import React from 'react';

const FlatList = ({ 
  data = [], 
  renderItem, 
  keyExtractor,
  style,
  horizontal = false,
  numColumns = 1,
  ItemSeparatorComponent,
  ListHeaderComponent,
  ListFooterComponent,
  ListEmptyComponent,
  onEndReached,
  onEndReachedThreshold = 0.1,
  refreshing = false,
  onRefresh,
  ...props 
}) => {
  const convertStyle = (rnStyle) => {
    if (!rnStyle) return {};
    return { ...rnStyle };
  };
  
  const containerStyle = {
    display: 'flex',
    flexDirection: horizontal ? 'row' : 'column',
    overflow: 'auto',
    ...convertStyle(style)
  };
  
  const gridStyle = numColumns > 1 ? {
    display: 'grid',
    gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
    gap: '8px'
  } : {};
  
  const handleScroll = (e) => {
    if (onEndReached) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const threshold = scrollHeight * onEndReachedThreshold;
      
      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        onEndReached();
      }
    }
  };
  
  if (!data || data.length === 0) {
    return (
      <div style={containerStyle}>
        {ListHeaderComponent && <div>{ListHeaderComponent}</div>}
        {ListEmptyComponent && <div>{ListEmptyComponent}</div>}
        {ListFooterComponent && <div>{ListFooterComponent}</div>}
      </div>
    );
  }
  
  return (
    <div 
      style={containerStyle}
      onScroll={handleScroll}
      {...props}
    >
      {ListHeaderComponent && <div>{ListHeaderComponent}</div>}
      
      <div style={gridStyle}>
        {data.map((item, index) => {
          const key = keyExtractor ? keyExtractor(item, index) : index.toString();
          
          return (
            <div key={key}>
              {renderItem({ item, index })}
              {ItemSeparatorComponent && index < data.length - 1 && (
                <div>{ItemSeparatorComponent}</div>
              )}
            </div>
          );
        })}
      </div>
      
      {ListFooterComponent && <div>{ListFooterComponent}</div>}
    </div>
  );
};

export default FlatList;